import React from "react";


function ObjetoLegal() {
    return (
        <div>
            <h3>
                Objeto:
            </h3>
            <p>
                La presente página web tiene por objeto ofrecer a los usuarios información sobre
                los servicios y actividades de Reco, dedicada a la construcción de empresas.
            </p>
        </div>
    )
}

export default ObjetoLegal;